import React, { useRef } from 'react';
import CompanyCard from '../components/Mescomponents/CompanyCard';
import SectionTitle from '../components/Mescomponents/SectionTitle';
import { ArrowLeft, ArrowRight } from "lucide-react";
import logo1 from '../assets/imagesLand/ALL-removebg-preview.png';
import logo2 from '../assets/imagesLand/kalite-removebg-preview.png';
import logo3 from '../assets/imagesLand/inayah.png';
import logo4 from '../assets/imagesLand/Eline.jpg';
import logo5 from '../assets/imagesLand/lekk.png';
import logo6 from '../assets/imagesLand/sira.jpg';
import logo7 from '../assets/imagesLand/atyd.jpg';
import logo8 from '../assets/imagesLand/sen.jpg';

interface Testimonial {
  name: string;
  logo: string;
  description: string;
}

type ScrollDirection = 'left' | 'right';

const TESTIMONIALS: Testimonial[] = [
  { name: 'All-In-Tech', logo: logo1, description: 'All-In-Tech est une entreprise sénégalaise spécialisée dans la fourniture de solutions technologiques de pointe. ' },
  { name: 'Karitédema', logo: logo2, description: 'Karitédiema est une marque de produits cosmétiques naturels et équitables, spécialisée dans les soins à base de beurre de karité biologique. ' },
  { name: 'Inayah', logo: logo3, description: 'Inayah réinvente les soins beauté en mêlant recettes traditionnelles authentiques, ingrédients naturels et savoir-faire transmis de génération en génération.' },
  { name: 'Eline Biot', logo: logo4, description: 'Des soins cosmétiques naturels, fabriqués au Sénégal, pensés pour purifier, réparer et sublimer votre peau et vos cheveux au quotidien. ' },
  { name: 'Tech Pro', logo: logo5, description: 'Lekku Mbed est une expérience culinaire moderne ancrée dans les saveurs locales. un concept revisite la street food sénégalaise avec créativité, exigence et générosité.' },
  { name: 'Market Plus', logo: logo6, description: 'Sira yiité est Magasin de chaussures sandales stylées, du cuir 100% local, un savoir-faire artisanal qui fait la différence…' },
  { name: 'BizPro', logo: logo7, description: 'ATydi Afro Hair est une marque de soins capillaires naturels dédiée aux cheveux texturés, crépus, bouclés et frisés spécialement pensée pour les enfants..' },
  { name: 'AfriTech', logo: logo8, description: 'Vente de crochets , perruques , postiches , faux locs et mèches de tout genre en ligne.' },
];

export default function TestimonialsSection(): React.JSX.Element {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: ScrollDirection): void => {
    const amount = 300;
    if (!scrollRef.current) return;

    if (direction === 'left') {
      scrollRef.current.scrollBy({ left: -amount, behavior: 'smooth' });
    } else {
      scrollRef.current.scrollBy({ left: amount, behavior: 'smooth' });
    }
  };

  return (
    <section className="py-6 px-6 bg-[#f7f8fa]">
      <div className="max-w-[1100px] mx-auto mt-5">

        {/* TITLE */}
        <div className="text-center mb-[60px]">
          <SectionTitle
            label=""
            title="Ils utilisent"
            highlight="EasyMarket"
            subtitle={
              <>
                Plus de <span className="font-extrabold">100 commerçants</span> nous font confiance !
              </>
            }
            center
            light={false}
          />
        </div>

        {/* CAROUSEL */}
        <div className="relative">

          <div
            ref={scrollRef}
            className="scroll-container flex gap-3 overflow-x-auto scroll-smooth pb-[10px]"
          >
            {TESTIMONIALS.map((item, i) => (
              <CompanyCard key={i} {...item} />
            ))}
          </div>

          {/* BUTTONS */}
          <div className="flex justify-end gap-[10px] mt-5">

            <button
              onClick={() => scroll('left')}
              className="w-10 h-[30px] rounded-md border-none bg-transparent text-[#053965] flex items-center justify-center cursor-pointer"
            >
              <ArrowLeft size={18} />
            </button>

            <button
              onClick={() => scroll('right')}
              className="w-10 h-[30px] border-none bg-[#053965] text-white flex items-center justify-center cursor-pointer"
            >
              <ArrowRight size={18} />
            </button>

          </div>
        </div>
      </div>
    </section>
  );
}